import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  AlertComponent,
  ButtonComponent,
  CardAltComponent,
  CardBorderlessComponent,
  CardComponent as BackstageCardComponent,
  ColorBgIconComponent,
  GlobalSearchBarComponent,
  NotificationsComponent,
  ProductIconComponent
} from '@forgerock/backstage-ui-components';
import { APP_NAME, UiCoreModule } from '@forgerock/backstage-ui-core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardDownloadsPanelComponent } from './dashboard-downloads-panel/dashboard-downloads-panel.component';
import { DashboardLinksPanelComponent } from './dashboard-links-panel/dashboard-links-panel.component';
import {
  DashboardMaintenanceInfoPanelComponent
} from './dashboard-maintenance-info-panel/dashboard-maintenance-info-panel.component';
import { DashboardUniversityPanelComponent } from './dashboard-university-panel/dashboard-university-panel.component';
import {
  DashboardVerifyEmailPanelComponent
} from './dashboard-verify-email-panel/dashboard-verify-email-panel.component';
import { DashboardComponent } from './dashboard/dashboard.component';


@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [
    AppComponent,
    DashboardComponent,
    DashboardDownloadsPanelComponent,
    DashboardLinksPanelComponent,
    DashboardMaintenanceInfoPanelComponent,
    DashboardUniversityPanelComponent,
    DashboardVerifyEmailPanelComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CardAltComponent,
    CardBorderlessComponent,
    UiCoreModule,
    AppRoutingModule,
    AlertComponent,
    BackstageCardComponent,
    ColorBgIconComponent,
    NotificationsComponent,
    GlobalSearchBarComponent,
    ButtonComponent,
    ProductIconComponent
  ],
  providers: [
    { provide: APP_NAME, useValue: 'bs_dashboard-ui' }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {}
